module.exports = __webpack_public_path__ + "img/youtube.15b1cf40.svg";